import {Component, Input} from '@angular/core';
import {Observable} from "rxjs";

@Component({
  selector: 'pt-image-with-text',
  template: `
    <div class="image-with-text">
      <img src="{{image}}" alt="Image">
      <div>
        <p *ngFor="let text of texts" [innerHTML]="text | async"></p>
      </div>
    </div>
  `,
  styles: [`
    .image-with-text {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin: 5px 0;
    }
    .image-with-text img {
      width: 40px;
      padding: 5px;
    }

    .image-with-text div {
      text-align: left;
      margin: 0;
      padding: 5px;
    }
    .image-with-text div p { padding: 0; margin: 0;}
  `]
})
export class ImageWithTextComponent {
  @Input() image: string;
  @Input() texts: Observable<string>[];
}
